/* eslint-disable @typescript-eslint/no-explicit-any */
import Vue from "vue";
import router from "@/router";
import { acceptTerms } from "@/services/terms-and-conditions.service";
import { TermsAndConditionsBlock } from "@/interfaces/terms-and-conditions.interface";

const termsState = {
  state: () => ({
    currentEventId: null as number | null,
    terms: null as TermsAndConditionsBlock | null,
    termsModalOpen: false,
    termsLoading: false,
    termsModalOpening: false, // Mutex: evita doble apertura por timing
  }),

  mutations: {
    setCurrentEventId(state: any, eventId: number | null) {
      state.currentEventId = eventId;
    },
    setTerms(state: any, terms: TermsAndConditionsBlock | null) {
      state.terms = terms;
    },
    setTermsModalOpen(state: any, open: boolean) {
      state.termsModalOpen = open;
    },
    setTermsLoading(state: any, loading: boolean) {
      state.termsLoading = loading;
    },
    setTermsModalOpening(state: any, opening: boolean) {
      state.termsModalOpening = opening;
    },
  },

  getters: {
    needsTermsModal: (state: any) =>
      !!state.terms && state.terms.status && state.terms.status.has_accepted === false,
    isTermsBlocked: (state: any) =>
      !!state.terms && state.terms.status && state.terms.status.is_blocked === true,
    canSkipTerms: (state: any) =>
      !!state.terms && state.terms.status && state.terms.status.can_skip === true,
  },

  actions: {
    setEventTermsContext(
      { commit }: any,
      payload: { eventId: number | null; terms: TermsAndConditionsBlock | null }
    ) {
      commit("setCurrentEventId", payload.eventId);
      commit("setTerms", payload.terms);
    },

    resetEventTermsContext({ commit }: any) {
      commit("setCurrentEventId", null);
      commit("setTerms", null);
      commit("setTermsModalOpen", false);
      commit("setTermsLoading", false);
      commit("setTermsModalOpening", false);
    },

    openTermsModal({ commit, state }: any) {
      // Mutex fuerte: si ya está abierto (o abriéndose), no volver a disparar
      if (state.termsModalOpen || state.termsModalOpening) return;
      commit("setTermsModalOpening", true);
      commit("setTermsModalOpen", true);
      // Liberar mutex en el próximo tick
      setTimeout(() => commit("setTermsModalOpening", false), 0);
    },

    closeTermsModal({ commit, getters }: any) {
      if (getters.isTermsBlocked) return;
      commit("setTermsModalOpen", false);
      commit("setTermsModalOpening", false);
    },

    async acceptTerms({ commit, state }: any): Promise<void> {
      if (!state.terms || !state.currentEventId) return;

      commit("setTermsLoading", true);
      try {
        const basePath = router?.currentRoute?.fullPath || "/";
        const response = await acceptTerms(basePath, state.currentEventId);
        const payload: any = response.data as any;
        const updated =
          payload?.data?.terms_and_conditions ??
          payload?.terms_and_conditions ??
          null;

        commit("setTerms", updated);

        if (updated && updated.status && updated.status.has_accepted === true) {
          commit("setTermsModalOpen", false);
          commit("setTermsModalOpening", false);
        }
      } catch (e) {
        // Mantener modal abierto y avisar al usuario
        Vue.$toast.error("No pudimos aceptar los términos. Intentá nuevamente.");
      } finally {
        commit("setTermsLoading", false);
      }
    },

    skipTerms({ commit, getters }: any) {
      if (!getters.canSkipTerms) return;
      commit("setTermsModalOpen", false);
      commit("setTermsModalOpening", false);
    },
  },
};

export default termsState;


